import "./index.css";
import logo from "./assets/logo.png";

export function App() {
  return (
    <div className="app">
      <div className="logo-container">
        <img src={logo} alt="folksong logo" className="folksong-logo" />
      </div>
    </div>
  );
}

export default App;
